import baseAPI from './api';
import baseURLs from '../configs/baseURLs';


//  criando uma classe gerica para atendenteServices, para reutilizar o codigo toda vez que eu precisar chamar o end poit atendente

class DeliveryServices {
    constructor (){
        this.api = baseAPI(baseURLs.API_DELIVERY);
    }

    async getAll(getAllDeliveryFinished, signal) {  

        const result = await this.api.post('listarDelivery',  getAllDeliveryFinished , {signal});
        // pegando o retorno que vem no response
        
        return result.data;
    }

    async getAllDeliveryStatus(getAllDeliveryStatus, signal) {  

        const result = await this.api.post('dashboardDelivery',  getAllDeliveryStatus, {signal});
        // pegando o retorno que vem no response
        
        return result.data;
        
    }

    async getAllProductsOrder(getAllProductsOrder) {  

        const result = await this.api.post('listarProdutoDelivery',  getAllProductsOrder);
        // pegando o retorno que vem no response
        return result.data;
        
    }


    async getEstablishmentStatus(modelStatus) {
        const result = await this.api.post('carregarStatusCardapio', modelStatus);

        return result.data
    }

    async changeStablishmentStatus(changeStatus) {  

        const result = await this.api.post('statusCardapio',  changeStatus);
        // pegando o retorno que vem no response
        
        return result.data;
         
    }
    

    async listProductDelivery(listProductDelivery, signal) {  

        const result = await this.api.post('listarProdutoDelivery',  listProductDelivery, {signal});
        // pegando o retorno que vem no response
        
        return result.data;
        
    }
    
    async insertProductDelivery(inserirProdutoDelivery) {  

        const result = await this.api.post('inserirProdutoDelivery',  inserirProdutoDelivery);
        // pegando o retorno que vem no response
        
        return result.data;
        
    }

    async DeleteProductDelivery(DeleteProdutoDelivery) {  

        const result = await this.api.post('excluirProdutoDelivery',  DeleteProdutoDelivery);
        // pegando o retorno que vem no response
        
        return result.data;
        
    }

    async DeleteDelivery(DeleteDelivery) {  

        const result = await this.api.post('excluirDelivery',  DeleteDelivery);
        // pegando o retorno que vem no response
        
        return result.data;
        
    }

    async FinishDelivery(values) {  

        const result = await this.api.post('finalizarDelivery',  values );
        // pegando o retorno que vem no response
        
        return result.data;
        
    }


    async OrderReady(values) {  

        const result = await this.api.post('pedidoPronto',  values );
        // pegando o retorno que vem no response
        
        return result.data;
        
    }

    async SendOrderProductsPackage(values) {  

        const result = await this.api.post('inserirProdutoDeliveryLote',  values );
        // pegando o retorno que vem no response
        
        return result.data;
        
    }

    async SendOrderStatus(endPoint,values) {  

        const result = await this.api.post(endPoint,values);
        // pegando o retorno que vem no response
        
        return result.data;
        
    }
    
    async InsertDelivery(values) {  

        const result = await this.api.post('inserirDelivery',values);
        // pegando o retorno que vem no response
        
        return result.data;
        
    }

    
}


export default DeliveryServices;